exports["NO"] = require("./NO.js");
exports["IE"] = require("./IE.js");